import type { HelpEvent } from "./eventSchema"

/**
 * Emisor best-effort de telemetría del centro de ayuda público (/help).
 * Dispara un POST a /api/help-events con keepalive (sobrevive a la navegación)
 * y se traga cualquier error: la telemetría JAMÁS debe degradar /help.
 */
export function sendHelpEvent(payload: HelpEvent): void {
  try {
    fetch("/api/help-events", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {})
  } catch {
    /* best-effort */
  }
}
